export default function CarRulesController(
    $scope,
    carsFactory,
    rules,
    userService
) {
    'ngInject';

    const regionalSettings = userService.getRegionalSettings();

    $scope.isRulesExist = rules.IsRulesExist;

    if (rules.GuaranteeUntil) {
        rules.GuaranteeUntil = moment(rules.GuaranteeUntil, 'YYYY-MM-DD').format(regionalSettings.dateFormat);
    }

    $scope.rules = rules;
    $scope.isSurchargeCollapsed = rules.isSurcharge;

    $scope.chargeUnits = {
        0: ['km', 'km'],
        1: ['mile', 'miles'],
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/controllers/carsRulesCtrl.js